import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { FeatureService } from 'src/app/private/services/feature.service';
import { PackageService } from 'src/app/private/services/package.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-add-feature',
  imports: [SharedModule],
  templateUrl: './add-feature.component.html',
  styleUrl: './add-feature.component.scss'
})
export class AddFeatureComponent implements OnInit {
  @Input() featureData: any = null;
  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();
packageOptions = [];
  statusOptions = [
    { label: 'Active', value: 'Active' },
    { label: 'Inactive', value: 'Inactive' }
  ];

  // Category: fixed or limit
  categoryOptions = [
    { label: 'Fixed Feature', value: 'fixed' },
    { label: 'Credit Usage Feature', value: 'limit' }
  ];

  // Feature Level: module, feature, or subfeature
  featureLevelOptions = [
    { label: 'Module', value: 'module' },
    { label: 'Module Feature', value: 'module_feature' },
    // { label: 'Sub-Module', value: 'submodule' },
    // { label: 'Sub-Module Feature', value: 'submodule_feature' }
  ];

  // Parent Feature options (loaded from API)
  parentFeatureOptions: Array<{ label: string; value: string }> = [];

  unitTypeOptions = [
    { label: 'Users', value: 'users' },
    { label: 'GB (Storage)', value: 'GB' },
    { label: 'Campaigns', value: 'campaigns' },
    { label: 'Templates', value: 'templates' },
    { label: 'Leads', value: 'leads' },
    { label: 'Contacts', value: 'contacts' },
    { label: 'Deals', value: 'deals' },
    { label: 'Invoices', value: 'invoices' },
    { label: 'Quotes', value: 'quotes' },
    { label: 'Contact Groups', value: 'contact_groups' },
    { label: 'Group Contacts', value: 'group_contacts' },
    { label: 'Email Sends', value: 'email_sends' },
    { label: 'SMS Sends', value: 'sms_sends' },
    { label: 'WhatsApp Marketing Messages', value: 'whatsapp_marketing_messages' },
    { label: 'Tasks', value: 'tasks' },
    { label: 'Projects', value: 'projects' },
    { label: 'Pipelines', value: 'pipelines' },
    { label: 'Custom Fields', value: 'custom_fields' },
    { label: 'Workflows', value: 'workflows' },
    { label: 'Automations', value: 'automations' },
    { label: 'Reports', value: 'reports' },
    { label: 'Dashboards', value: 'dashboards' },
    { label: 'API Calls', value: 'api_calls' },
    { label: 'Integrations', value: 'integrations' },
    { label: 'Team Members', value: 'team_members' },
    { label: 'Products', value: 'products' },
    { label: 'Services', value: 'services' },
    { label: 'Tickets', value: 'tickets' },
    { label: 'Knowledge Base Articles', value: 'kb_articles' },
    { label: 'Email Accounts', value: 'email_accounts' },
    { label: 'Phone Numbers', value: 'phone_numbers' },
    { label: 'Documents', value: 'documents' },
    { label: 'Attachments (MB)', value: 'attachments_mb' },
    { label: 'Meetings', value: 'meetings' },
    { label: 'Appointments', value: 'appointments' },
    { label: 'Notes', value: 'notes' },
    { label: 'Tags', value: 'tags' },
    { label: 'Segments', value: 'segments' },
    { label: 'Landing Pages', value: 'landing_pages' },
    { label: 'Forms', value: 'forms' },
    { label: 'Surveys', value: 'surveys' },
    { label: 'Email Templates', value: 'email_templates' },
    { label: 'SMS Templates', value: 'sms_templates' },
    { label: 'WhatsApp Templates', value: 'whatsapp_templates' },
    { label: 'Broadcast Campaigns', value: 'broadcast_campaigns' },
    { label: 'Drip Campaigns', value: 'drip_campaigns' },
    { label: 'A/B Tests', value: 'ab_tests' },
    { label: 'Web Forms', value: 'web_forms' },
    { label: 'Chatbots', value: 'chatbots' },
    { label: 'Live Chat Sessions', value: 'live_chat_sessions' }
  ];

  // Action Types for features
  actionOptions = [
    { label: 'Create', value: 'create', icon: 'pi-plus' },
    { label: 'Read/View', value: 'read', icon: 'pi-eye' },
    { label: 'Update/Edit', value: 'update', icon: 'pi-pencil' },
    { label: 'Delete', value: 'delete', icon: 'pi-trash' },
    { label: 'Export', value: 'export', icon: 'pi-download' },
    { label: 'Import', value: 'import', icon: 'pi-upload' },
    { label: 'Filter', value: 'filter', icon: 'pi-filter' },
   
    
  ];

  featureForm = this.fb.group({
    feature_key: ['', Validators.required],          // e.g. lead, advanced_lead_management
    label: ['', Validators.required],                // Display name
    description: [''],
    status: ['Active', Validators.required],
    category: ['', Validators.required],    // fixed | limit
    feature_level: ['module', Validators.required],  // module | feature | subfeature
    parent_feature_key: [''],                        // e.g. lead → advanced_lead_management
    unit_type: [''],                                 // ONLY for limit features (email, users, etc)
    actions: [[]],                                    // Array of action types (create, read, update, delete, etc.)
    packages_id: [[]]                                   // Array of selected package IDs
  });

  submitted = false;
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private api: FeatureService,
    private messageService: MessageService,
    private packageService: PackageService
  ) { }
  
  loadPackagesList() {
    let params = {
      "page": 0,
      "limit": 10000,
      "where": { status: 'Active'},
      "order": {
        "col": "\"package\".\"updatedAt\"",
        "dir": "DESC"
      }
    }
    this.packageService.getAllPackage(params).subscribe({
      next: (response: any) => {
        console.log('Packages API response:', response);  
        let packages = [];
        if (response && response.data) {
          packages = response.data;
        } else if (response && response.rows) {
          packages = response.rows;
        } else if (Array.isArray(response)) {
          packages = response;
        }
        
        this.packageOptions = packages.map((pkg: any) => ({
          label: pkg.package_name,
          value: Number(pkg.package_id) // Ensure numeric value to match form data
        }));
        
        console.log('Package options formatted:', this.packageOptions);
      },
      error: (error) => {
        console.error('Error loading packages:', error);
      }
    });
  }
  ngOnInit(): void {
    // Load parent features for dropdown
    this.loadParentFeatures();
    this.loadPackagesList();

    // If editing, refetch feature data to ensure we have relations (packages)
    if (this.featureData?.id) {
       this.refetchFeatureData(this.featureData.id);
    } else if (this.featureData) {
       this.populateForm();
    }

    // Clear fields based on category selection
    this.featureForm.get('category')?.valueChanges.subscribe(category => {
      if (category === 'fixed') {
        // Clear unit_type for fixed features
        this.featureForm.patchValue({ unit_type: '' }, { emitEvent: false });
      } else if (category === 'limit') {
        // Clear feature_level, parent_feature_key, and actions for limit features
        this.featureForm.patchValue({ 
          feature_level: 'module',
          parent_feature_key: '',
          actions: null
        }, { emitEvent: false });
      }
    });
  }

  refetchFeatureData(id: any) {
    this.isLoading = true;
    const body = {
      where: { id: id },
      include: ['packages']
    };
    
    this.api.findAndCountAllFeature(body).subscribe({
      next: (response: any) => {
        let features = [];
        if (response && response.data) {
          features = response.data;
        } else if (response && response.rows) {
          features = response.rows;
        } else if (Array.isArray(response)) {
          features = response;
        }

        if (features.length > 0) {
          this.featureData = features[0];
          console.log('Refetched feature data with packages:', this.featureData);
        }
        this.populateForm();
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error refetching feature data:', error);
        this.populateForm(); // Fallback
        this.isLoading = false;
      }
    });
  }

  populateForm() {
    console.log('Populate Form featureData:', this.featureData);
    
    // Prioritize packages_id if available (as requested), otherwise fallback to packages
    const existingPackages = this.featureData.packages_id || this.featureData.packages || [];
    console.log('Existing packages raw:', existingPackages);
    
    // Handle if it's an array of strings/numbers or objects
    const mappedPackages = existingPackages.map((p: any) => {
      const val = p?.package_id || p;
      // Convert to number if possible to ensure type matching with options
      return !isNaN(val) ? Number(val) : val;
    });
    
    console.log('Mapped packages for form:', mappedPackages);

    this.featureForm.patchValue({
      feature_key: this.featureData.feature_key,
      label: this.featureData.label,
      description: this.featureData.description,
      status: this.featureData.status,
      category: this.featureData.category || 'fixed',
      feature_level: this.featureData.feature_level || 'module',
      parent_feature_key: this.featureData.parent_feature_key || '',
      unit_type: this.featureData.unit_type || '',
      actions: this.featureData.actions || [],
      packages_id: mappedPackages
    });
  }

  loadParentFeatures(): void {
    // Fetch all features to populate parent dropdown
    this.api.getAllFeatures({}).subscribe({
      next: (response: any) => {
        console.log('Parent features API response:', response);
        
        let features = [];
        
        // Handle different response structures
        if (response && response.data) {
          features = response.data;
        } else if (response && response.rows) {
          features = response.rows;
        } else if (Array.isArray(response)) {
          features = response;
        }
        
        console.log('Extracted features:', features);
        
        if (features && features.length > 0) {
          // Map features to dropdown options
          this.parentFeatureOptions = features
            .filter((feature: any) => feature.feature_key && feature.label)
            .map((feature: any) => ({
              label: `${feature.label} (${feature.feature_key})`,
              value: feature.feature_key
            }));
          
          console.log('Parent feature options:', this.parentFeatureOptions);
        } else {
          console.warn('No features found in response');
        }
      },
      error: (error) => {
        console.error('Error loading parent features:', error);
      }
    });
  }

  submitForm() {
    this.submitted = true;
    if (this.featureForm.invalid) return;

    const payload: any = {
      ...this.featureForm.value
    };

    this.isLoading = true;

    if (this.featureData?.id) {
      // Update existing feature
      payload.id = this.featureData.id;
      this.api.updateFeature(payload).subscribe({
        next: () => {
          this.isLoading = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Feature updated successfully'
          });
          this.reload.emit();
          this.close.emit();
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to update feature'
          });
          this.isLoading = false;
        }
      });
    } else {
      // Create new feature
      this.api.createFeature(payload).subscribe({
        next: () => {
          this.isLoading = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Feature created successfully'
          });
          this.reload.emit();
          this.close.emit();
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to create feature'
          });
          this.isLoading = false;
        }
      });
    }
  }

  handleCloseDialog() {
    this.close.emit();
  }

  get isEditMode(): boolean {
    return !!this.featureData?.id;
  }
}
